import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class BiddingOpenAmountDetailV2Api extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'bidding-open-amount-detail-v2'
  }

}